import { combineReducers } from 'redux'

import auth from './auth'
import user from './user'
import global from './global'

const rootReducer = combineReducers({ auth, user, global })

export default rootReducer



// WEBPACK FOOTER //
// app/javascript/src/reducers/index.js